"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const classnames_1 = __importDefault(require("classnames"));
const immutable_1 = require("immutable");
const react_use_1 = require("react-use");
const mui_1 = require("tss-react/mui");
const List_1 = __importDefault(require("@mui/material/List"));
const Divider_1 = __importDefault(require("@mui/material/Divider"));
const Fade_1 = __importDefault(require("@mui/material/Fade"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const Slide_1 = __importDefault(require("@mui/material/Slide"));
const Skeleton_1 = __importDefault(require("@mui/material/Skeleton"));
const core_1 = require("companion-app-components/utils/core");
const accounts_1 = require("companion-app-components/flux/accounts");
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const accountsSelectors_1 = require("companion-app-components/flux/accounts/accountsSelectors");
const accountGroupsSelectors_1 = require("companion-app-components/flux/account-groups/accountGroupsSelectors");
const bank_svg_1 = __importDefault(require("assets/zero-state-images/bank.svg"));
const investments_svg_1 = __importDefault(require("assets/nav-menu/investments.svg"));
const selectors_1 = require("data/accountNodes/selectors");
const RendersCount_1 = __importDefault(require("components/RendersCount"));
const QTextButton_1 = __importDefault(require("components/QTextButton"));
const Dump_1 = __importDefault(require("components/Dump"));
const EmptyEntityPage_1 = __importDefault(require("containers/EmptyEntityPage"));
const AccountRow_1 = __importDefault(require("./AccountRow"));
const types_1 = require("./types");
const styles_1 = __importDefault(require("./styles"));
const useStyles = (0, mui_1.makeStyles)()(styles_1.default);
const AccountList = (props) => {
    const { classes, theme } = useStyles();
    const isLoading = (0, react_redux_1.useSelector)((state) => accounts_1.accountsSelectors.getLoadPending(state));
    const accountNodesTree = (0, react_redux_1.useSelector)((state) => (0, selectors_1.getAccountNodesTree)(state));
    const allAccountsById = (0, react_redux_1.useSelector)((state) => (0, accountsSelectors_1.getAllAccountIds)(state));
    const accountsById = (0, react_redux_1.useSelector)((state) => (0, accountsSelectors_1.getAccountsById)(state));
    const isEntitySharedUser = (0, react_redux_1.useSelector)(accountGroupsSelectors_1.isEntityShareUser);
    const prevAccountNodesTree = (0, react_use_1.usePrevious)(accountNodesTree);
    const mkDisplayOptionsMapEntry = (path, node) => {
        let children = null;
        let expandParent = true;
        if (node.children) {
            children = (0, immutable_1.OrderedMap)(node.children.map((child) => {
                const pathToChild = path.concat(['children', child.id]);
                const displayNodeEntry = mkDisplayOptionsMapEntry(pathToChild, child);
                // start separate and hidden sections as collapsed
                if (path.includes('SEPARATE') || path.includes('HIDDEN')) {
                    expandParent = false;
                }
                if (displayNodeEntry[1].selected) {
                    expandParent = true;
                }
                return displayNodeEntry;
            }));
        }
        const displayOptions = (0, types_1.makeDisplayOptions)({
            selected: false,
            expand: expandParent,
            path: (0, immutable_1.List)(path),
            children,
        });
        return [node.id, displayOptions];
    };
    const mkDisplayOptionsMap = (newAccountNodesTree) => ((0, immutable_1.Map)(newAccountNodesTree.map((node) => mkDisplayOptionsMapEntry([node.id], node))));
    const [accountListState, setAccountListState] = React.useState({
        displayOptionsMap: mkDisplayOptionsMap(accountNodesTree),
    });
    const numAccounts = isLoading ? 0 : accountNodesTree.size;
    // Somewhat temporary to AB test the account list havving "Add" buttons, see SIMPL-9339 for more
    const showOptionToAddUnderAccounts = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlags(state).get('accountListSubLevelAdd') && false);
    const accountNodesById = (0, react_redux_1.useSelector)((state) => (0, selectors_1.getAccountNodesById)(state, props));
    let accountsToShowAddOptionUnder = [];
    if (showOptionToAddUnderAccounts) {
        const accountIdToDisplayLabel = { BANKING: 'Banking', LOAN: 'Loans', ASSET: 'Property', INVESTMENT: 'Investments' };
        accountsToShowAddOptionUnder = ['BANKING', 'INVESTMENT', 'ASSET', 'LOAN']
            .filter((id) => !accountNodesById.has(id))
            .map((id) => accountIdToDisplayLabel[id]);
    }
    const handleExpandCollapse = (displayOptions) => {
        if (!displayOptions.children) {
            // cannot expand/collapse non-parent nodes
            return;
        }
        setAccountListState({
            displayOptionsMap: accountListState.displayOptionsMap.setIn(displayOptions.path, displayOptions.set('expand', !displayOptions.expand)),
        });
        const trackObj = {
            state: displayOptions.expand ? 'collapsed' : 'expanded',
            level: displayOptions.path.size === 3 ? 2 : 1,
        };
        core_1.tracker.track(core_1.tracker.events.accountListArrow, trackObj);
    };
    const renderDrawerSkeleton = () => {
        const skeletonDrawer = [];
        for (let i = 0; i < 5; i += 1) {
            skeletonDrawer.push(<div key={`skeleton-${i}`} className={classes.skeletonGroupWrapper}>
          <Skeleton_1.default variant="rectangular" className={(0, classnames_1.default)(classes.skeletonBlock, 'large')}/>
          <Skeleton_1.default variant="rectangular" className={classes.skeletonBlock}/>
          <Skeleton_1.default variant="rectangular" className={(0, classnames_1.default)(classes.skeletonBlock, 'small')}/>
        </div>);
        }
        return (<div className={classes.skeletonWrapper}>
        <Skeleton_1.default variant="rectangular" className={(0, classnames_1.default)(classes.skeletonBlock, 'netWorth')}/>
        {skeletonDrawer}
      </div>);
    };
    React.useEffect(() => {
        if (accountNodesTree !== prevAccountNodesTree) {
            const displayOptionsMap = mkDisplayOptionsMap(accountNodesTree);
            setAccountListState({ displayOptionsMap });
        }
    }, [accountNodesTree, prevAccountNodesTree]); // eslint-disable-line react-hooks/exhaustive-deps
    return (<div className={classes.base} id="qCard-account-list">
      <Dump_1.default obj={{ accountNodesTree }} sx={{ left: 'unset', right: 0 }}/>
      {isLoading &&
            <div className={classes.loadingStateContainer}>
          <Fade_1.default in={isLoading} unmountOnExit>
            <CircularProgress_1.default sx={{ color: theme.palette.primaryBlue }}/>
          </Fade_1.default>
        </div>}
      {/* This skeleton for the accountDrawer on the Transactions page for acme is currently not in use.
        It may be added in the future */}
      {(isLoading && false) && renderDrawerSkeleton()}
      {!isLoading && numAccounts > 0 &&
            <List_1.default dense classes={{
                    root: props.borderBottom ? classes.rootWithBorderBottom : classes.root,
                }} className={props.dimAccountList ? 'dim' : ''}>
          {accountListState.displayOptionsMap && accountNodesTree.map((node, i) => {
                    if (node.hide) {
                        return (<div key={node.id}/>);
                    }
                    return (<AccountRow_1.default key={node.id} id={`${node.displayLabel}-${i}`} node={node} dense displayOptions={accountListState.displayOptionsMap.get(node.id)} onClick={props.onSelect} onExpandCollapse={handleExpandCollapse} selectedNodeId={props.selectedNodeId} showColors={props.showColors} balanceType={props.balanceType} omitCents={props.omitCents}/>);
                })}

          <Box_1.default marginTop={2} paddingLeft={2} paddingRight={2} display={'flex'} flexDirection={'column'} alignItems={'flex-start'}>
            {accountsToShowAddOptionUnder.map((accountType, i) => (<Slide_1.default key={`transition-${accountType}-empty`} direction={'up'} in style={{ width: '100%' }} timeout={400 + (accountNodesTree.size + i) * 50}>
                <Box_1.default>
                  <Fade_1.default in timeout={2500 + ((accountNodesTree.size + i) * 50)}>
                    <Box_1.default display={'flex'} flexDirection={'column'} alignItems={'flex-start'}>
                      <div className={classes.emptyAccountTypeHeader}>
                        <Typography_1.default variant={'subtitle1'}>{accountType}</Typography_1.default>
                      </div>
                      <QTextButton_1.default className={classes.emptyAccountTypeAddButton} onClick={props.handleAddInstitutionLogin(`account list${props.prefix === 'dashboard' ? ' dashboard' : ' txns'}`, accountType === 'Property')} variant={'body2'} title={`+ ${accountType === null || accountType === void 0 ? void 0 : accountType.replace(/s$/, '')} account`}/>
                    </Box_1.default>
                  </Fade_1.default>
                </Box_1.default>
              </Slide_1.default>))}
          </Box_1.default>

          {props.borderBottom &&
                    <Divider_1.default classes={{
                            root: classes.dividerRoot,
                        }}/>}
        </List_1.default>}

      {!isLoading && !props.accountNodeName && ((isEntitySharedUser && (allAccountsById === null || allAccountsById === void 0 ? void 0 : allAccountsById.size) === 0) || ((allAccountsById === null || allAccountsById === void 0 ? void 0 : allAccountsById.size) >= 1 && accountsById.size === 0)) && (<div className={classes.zeroStateContainer}>
          <EmptyEntityPage_1.default />
        </div>)}

      {!isLoading && !props.accountNodeName && (allAccountsById === null || allAccountsById === void 0 ? void 0 : allAccountsById.size) === 0 && !isEntitySharedUser &&
            <div className={classes.zeroStateContainer}>
          <img alt="no transactions" src={bank_svg_1.default}/>
          <br />
          <div className={classes.zeroStateTextHeadline}>No synced financial accounts</div>
          <div className={classes.zeroStateTextBody}>All your connected financial accounts will be displayed here.</div>
        </div>}
      {props.accountNodeName === 'INVESTMENT' && !isLoading && !props.accountNode &&
            <div className={classes.zeroStateContainer}>
          <img alt="no investments" src={investments_svg_1.default}/>
          <br />
          <div className={classes.zeroStateTextHeadline}>No synced investment accounts</div>
          <div className={classes.zeroStateTextBody}>All your connected investment accounts will be displayed here.</div>
        </div>}
      <RendersCount_1.default id="accountDrawer"/>
    </div>);
};
exports.default = AccountList;
